import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Input from "@mostrans/web-components/components/base/Input";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Typography
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useHistory, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { insertLogCFIT } from "../../../../graphql/mutations";
import { getCFIT, getLogActivityCFIT } from "../../../../graphql/query";
import { getDataCFIT } from "../../../../shared/atom/getDataCFIT";
import { swalRemoveChild } from "../../../../shared/helpers";
import SimulationTest from "./Mostest1/SimulationTest";
import { GoToNextSection, checkValuesHasNull } from "./helpers";

const Section2 = () => {
  const waktuPengerjaan = 420000;
  const { showConfirmationModal } = useConfirmationModal();
  const [Loading, setLoading] = useState(true);

  const { id } = useParams();
  const client = useApolloClient();
  const [CFIT, setCFIT] = useRecoilState(getDataCFIT);
  const [listQuestion, setListQuestion] = useState([]);
  const [index, setIndex] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [loadCount, setLoadCount] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [selected, setSelected] = useState([]);
  const [values, setValues] = useState({
    show_instruction: true,
    cfit_second_remaining: waktuPengerjaan,
    data: [],
  });
  const [instruction, setInstruction] = useState(true);
  const [simulation, setSimulation] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    if (isEmpty(CFIT)) {
      //jika soal CFIT null maka get ulang
      getCFIT(client).then((result) => {
        setCFIT(result);
        setListQuestion(
          result.filter((item) => {
            return item.section === 2;
          })
        );
      });
    } else {
      if (!isEmpty(CFIT)) {
        setListQuestion(
          CFIT.filter((item) => {
            return item.section === 2;
          })
        );
      }
    }
    //Pertama kali load maka state value diperbarui
    const storageValue = localStorage.values;
    if (!storageValue) {
      //@remind get log from api
      getLogActivityCFIT(client).then((response) => {
        if (isEmpty(response)) {
          return;
        }
        response["data"] = response["log"];
        delete response.__typename;
        response.log.map((item) => {
          delete item?.__typename;
          return item;
        });
        delete response.log;
        const i = response.data.filter((item) => item?.section === 2).length;
        setIndex(i);
        setStartTime(Date.now() + response.cfit_second_remaining);
        setSelected(response?.data?.at(index)?.answer?.split(""));
        setValues(response);
      });
    } else {
      const decoded = JSON.parse(atob(storageValue));
      const i = decoded.data.filter((item) => item?.section === 2).length;
      setIndex(i);
      setStartTime(Date.now() + decoded.cfit_second_remaining);
      setSelected(decoded?.data?.at(index)?.answer?.split(""));
      setValues(decoded);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (Loading || !listQuestion.length) return;
    localStorage.setItem("values", btoa(JSON.stringify(values)));
    handleInstruction();
    insertLogActivity();
    if (values.cfit_second_remaining === 0 && !values.show_instruction) {
      handleNextSection();
    }
    if (listQuestion.length > 0) {
      if (values.isSection2Done) {
        handleNextSection();
      }
      if (GoToNextSection(values, listQuestion, index)) {
        if (checkValuesHasNull(values, listQuestion)) {
          confirmationAlert(
            "Jawaban anda banyak yang belum diisi, apakah anda yakin ingin menyelesaikan section 2?"
          );
        } else if (index === listQuestion.length - 1) {
          confirmationAlert(
            "Waktu anda masih tersisa, apakah anda yakin ingin menyelesaikan section 2?"
          );
        }
        return;
      } else if (listQuestion[index - 1]?.question_number === listQuestion.length) {
        handleNextSection();
      }
    }
    setLoaded(false); //@option showloading on image load
    setSelected("");
    if (
      index !== listQuestion?.at(-1)?.id &&
      values?.data?.slice(listQuestion.slice(0)[0]?.id - 1, listQuestion.slice(-1)[0]?.id)
        .length === index
    )
      return;

    setIndex(index + 1);
  }, [values, listQuestion]);

  const confirmationAlert = async (text) => {
    const show = await showConfirmationModal({
      contentText: <p>{text}</p>,
    });

    if (show.isConfirmed) {
      handleNextSection();
    }
  };

  const handleNextSection = () => {
    values.show_instruction = true;
    values.isSection2Done = true;
    insertLogActivity();
    localStorage.setItem("values", btoa(JSON.stringify(values)));
    history.push("/career/mostest-1/3");
  };

  const handleInstruction = () => {
    if (!listQuestion.length) return;
    const i = values.data.filter((item) => item?.section === 2).length;
    if (i === 0 && listQuestion[0].id - 1 !== values.data.length) {
      history.push("/career/mostest-1/1");
    }
    if (
      i < listQuestion.length &&
      i !== 0 &&
      values.cfit_second_remaining !== 0 &&
      values.data.length !== 0
    ) {
      setInstruction(false);
      return;
    }
    if (values.show_instruction === false) {
      setInstruction(false);
    } else {
      setInstruction(true);
    }
  };

  const onComplete = () => {
    swalRemoveChild();
    setValues({ ...values, cfit_second_remaining: 0 });
    if (!isEmpty(values.data[listQuestion.slice(-1)[0].id])) return;
    const data = [...values.data];
    data[listQuestion.slice(-1)[0].id - 1] = null;
    setValues({ ...values, cfit_second_remaining: 0, data: data });
  };

  const handleImageLoad = () => {
    if (loadCount <= 1) {
      setLoadCount(loadCount + 1);
    } else {
      setLoaded(true);
    }
  };

  const handleTime = () => {
    const timeLeft = startTime - Date.now();
    values.cfit_second_remaining = timeLeft;
  };

  const insertLogActivity = () => {
    insertLogCFIT(client, values);
  };

  const handleNext = () => {
    handleTime();

    const list = {
      section: listQuestion[index].section,
      question_number: listQuestion[index].question_number,
      answer: selected.sort().join(""),
    };

    const data = [...values.data];
    data[listQuestion.slice(0)[0].id - 1 + index] = list;
    setValues({
      ...values,
      data: data,
    });

    if (!isEmpty(values.data[listQuestion[index].id])) {
      setSelected(values.data[listQuestion[index].id]?.answer.split(""));
    } else {
      setSelected([]);
    }
  };

  const handleStart = () => {
    setValues({
      ...values,
      show_instruction: false,
      cfit_second_remaining: waktuPengerjaan,
    });
    setIndex(0);
    setInstruction(false);
    setStartTime(waktuPengerjaan + Date.now());
  };

  const handleStartSimulasi = () => {
    setSimulation(true);
  };

  return (
    <>
      {instruction ? (
        <React.Fragment>
          {(() => {
            if (simulation) {
              return <SimulationTest id={id} handleStart={handleStart} />;
            } else {
              return (
                <Card variant="outlined" sx={{ margin: "auto" }}>
                  <CardHeader
                    title={
                      <Typography variant="h5" component="h5">
                        Intruksi Section 2
                      </Typography>
                    }
                  />
                  <CardContent>
                    <Box>
                      <Typography className="text-textSecondary" component="p">
                        Pada bagian ini, anda akan menemukan 5 buah gambar yang disusun secara
                        berdampingan.
                      </Typography>
                      <Typography>
                        Tugas anda adalah menemukan tepat DUA gambar yang memiliki karateristik
                        serupa. TIGA gambar lainnya berfungsi sebagai pengecoh, sehingga
                        berhati-hatilah dalam menentukan pilih.
                      </Typography>
                    </Box>
                    <Box textAlign="center" marginTop="20px">
                      <Button variant="contained" color="primary" onClick={handleStartSimulasi}>
                        Mulai Simulasi
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              );
            }
          })()}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box margin={2} display={"flex"} justifyContent="space-between">
            <Typography
              component="div"
              fontSize={20}
              textTransform="uppercase"
              sx={{ fontWeight: "500 !important" }}>
              Soal
              {` ${listQuestion[index]?.question_number}/${listQuestion.length}`} | Section 2
            </Typography>

            <Typography
              component="div"
              fontSize={20}
              textTransform="uppercase"
              sx={{ fontWeight: "500 !important" }}>
              <Countdown
                date={startTime}
                renderer={({ minutes, seconds }) => {
                  return <span>{`${minutes} : ${seconds}`}</span>;
                }}
                onComplete={onComplete}
              />
            </Typography>
          </Box>
          <Divider sx={{ marginY: "20px" }} />
          {!loaded && (
            <Box textAlign="center" my={3}>
              <CircularProgress />
            </Box>
          )}
          <Box justifyContent="center" textAlign="center" display={!loaded ? "none" : ""}>
            {/* <Box margin="auto" width={550}>
          <img
            onLoad={() => handleImageLoad()}
            style={{
              display: "inline-block",
              width: "100%",
              height: "auto",
            }}
            src={listQuestion[index]?.question}
            alt={`Question ${listQuestion[index]?.question_number}`}
          />
        </Box> */}
            <Box>
              <Grid container textAlign="center" justifyContent="center" spacing={2} my={2}>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer1.score}</h5>
                    <Input
                      type="radio"
                      checked={selected?.includes("A")}
                      onChange={() => {
                        setSelected((old) => [listQuestion[index]?.answer1.score, ...old]);
                        if (selected.length >= 2) {
                          setSelected(selected.slice(0, -1));
                          setSelected((old) => [listQuestion[index]?.answer1.score, ...old]);
                        }
                        handleTime();
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer1.image}
                      alt={listQuestion[index]?.answer1.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer2.score}</h5>
                    <Input
                      type="radio"
                      checked={selected?.includes("B")}
                      onChange={() => {
                        setSelected((old) => [listQuestion[index]?.answer2.score, ...old]);
                        if (selected.length >= 2) {
                          setSelected(selected.slice(0, -1));
                          setSelected((old) => [listQuestion[index]?.answer2.score, ...old]);
                        }
                        handleTime();
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer2.image}
                      alt={listQuestion[index]?.answer2.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer3.score}</h5>
                    <Input
                      type="radio"
                      checked={selected?.includes("C")}
                      onChange={() => {
                        setSelected((old) => [listQuestion[index]?.answer3.score, ...old]);
                        if (selected.length >= 2) {
                          setSelected(selected.slice(0, -1));
                          setSelected((old) => [listQuestion[index]?.answer3.score, ...old]);
                        }
                        handleTime();
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer3.image}
                      alt={listQuestion[index]?.answer3.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer4.score}</h5>
                    <Input
                      type="radio"
                      checked={selected?.includes("D")}
                      onChange={() => {
                        setSelected((old) => [listQuestion[index]?.answer4.score, ...old]);
                        if (selected.length === 2) {
                          setSelected(selected.slice(0, -1));
                          setSelected((old) => [listQuestion[index]?.answer4.score, ...old]);
                        }
                        handleTime();
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer4.image}
                      alt={listQuestion[index]?.answer4.score}
                    />
                  </label>
                </Grid>
                <Grid item>
                  <label style={{ cursor: "pointer" }}>
                    <h5>{listQuestion[index]?.answer5.score}</h5>
                    <Input
                      type="radio"
                      checked={selected?.includes("E")}
                      onChange={() => {
                        setSelected((old) => [listQuestion[index]?.answer5.score, ...old]);
                        if (selected.length >= 2) {
                          setSelected(selected.slice(0, -1));
                          setSelected((old) => [listQuestion[index]?.answer5.score, ...old]);
                        }
                        handleTime();
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        width: 0,
                        height: 0,
                      }}
                    />
                    <img
                      onLoad={() => handleImageLoad()}
                      src={listQuestion[index]?.answer5.image}
                      alt={listQuestion[index]?.answer5.score}
                    />
                  </label>
                </Grid>
              </Grid>
            </Box>
            <Box my={5} textAlign="center">
              <Button
                onClick={() => handleNext()}
                disabled={
                  selected?.length === 2 &&
                    !selected.includes(undefined) &&
                    !selected.includes(null)
                    ? false
                    : true
                }
                variant="contained"
                color="primary">
                {listQuestion[index]?.question_number === listQuestion.length
                  ? "Selesai"
                  : "Selanjutnya"}
              </Button>
            </Box>
          </Box>
          <Divider sx={{ marginY: "20px" }} />
          <Box textAlign="center" display="grid" margin="20px">
            <ul>
              {listQuestion.map((item, i) => (
                <li key={i}>
                  <span
                    className="text-primary-main-hover bg-neutral-n2-hover"
                    onClick={() => {
                      setIndex(item.question_number - 1);
                      if (item.question_number === index + 1) {
                        return;
                      } else {
                        setLoaded(false);
                      }
                      if (!isEmpty(values.data[item.id - 1])) {
                        setSelected(values.data[item.id - 1]?.answer.split(""));
                      } else {
                        setSelected([]);
                      }
                    }}
                    style={{
                      float: "left",
                      width: "8%",
                      margin: "5px",
                      border: "2px solid #e1e1e1",
                      cursor: "pointer",
                      background:
                        (item.question_number === index + 1 && "#F0F0F0") ||
                        (values.data[item.id - 1]?.answer !== null &&
                          values.data[item.id - 1]?.answer !== undefined &&
                          "#D9D9D9"),
                    }}>
                    {i + 1}
                  </span>
                </li>
              ))}
            </ul>
          </Box>
        </React.Fragment>
      )}
    </>
  );
};

export default Section2;
